import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { AdministrationService } from '../../../../services/administration.service';

@Component({
    selector: 'dialog-other-government-edit-account-office',
    templateUrl: 'dialog.editaccoffice.html',
    styleUrls: ['dialog.editaccoffice.css']
})
export class EditAccountOfficeOtherGovernmentDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    editaccoffform: FormGroup;
    isSubmit: boolean = false;
    errorMessage: string = '';
    warrantAuthCode: string = this.data.warrantauthcode;
    selectedAccOff: string = this.data.accoff;
    selectedAccOffCode: string = this.data.accoffcode;

    constructor(public dialogRef: MatDialogRef<EditAccountOfficeOtherGovernmentDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private administrationService: AdministrationService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.editaccoffform = new FormGroup({
            accOffCode: new FormControl({ value: this.selectedAccOffCode, disabled: true }),
            accOff: new FormControl({ value: this.selectedAccOff, disabled: false }, [Validators.required, Validators.maxLength(32767)])
        });
    }

    onSubmit(form: FormGroup) {
        let cfm = confirm("Are you sure you want to save the change(s)?");

        if (cfm) {
            this.isSubmit = true;
            let accountOfficeDetail = {
                WarrantAuthCode: this.warrantAuthCode,
                AccOffCode: this.editaccoffform.get('accOffCode')!.value,
                AccOff: this.editaccoffform.get('accOff')!.value,
                MailTo: '',
                MailCc: '',
                MailBcc: ''
            }

            let save_sub = this.administrationService.othUpdateAccOff(accountOfficeDetail)
                .subscribe(
                    (value) => {
                        if (value.status === 204) {
                        } else if (value.status === 200) {
                            this.isSubmit = false;
                            this.dialogRef.close('Edit successful');
                        } else {
                        }
                    },
                    (error) => {
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(save_sub);
        } else {
            this.isSubmit = false;
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}